import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '../../../hooks/useIsMobile';

/**
 * Development-only fixed bar showing the current mobile route.
 * Hidden on desktop and stripped from production builds via NODE_ENV.
 */
const MobileDevPageInfoBar: React.FC = () => {
    const location = useLocation();
    const isMobile = useIsMobile();
    const isDev = process.env.NODE_ENV === 'development';
    const pathLabel = `${location.pathname}${location.search || ''}`;
    const shouldShow = isDev && isMobile;

    useEffect(() => {
        if (!shouldShow) return;
        const logdetails: string[] = [];
        logdetails.push('dev_page_info_bar_visible');
        logdetails.push(`path=${pathLabel}`);
        console.log('[MobileDevPageInfoBar]', logdetails.join(' | '));
    }, [shouldShow, pathLabel]);

    if (!shouldShow) {
        return null;
    }

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '40px',
                backgroundColor: '#f97316',
                color: '#000000',
                position: 'fixed',
                bottom: 0,
                left: 0,
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 1,
                py: 0.5,
                boxSizing: 'border-box',
                pointerEvents: 'none',
            }}
            aria-hidden="true"
        >
            <Box
                component="span"
                sx={{
                    fontSize: '13px',
                    fontWeight: 600,
                    fontFamily: 'chanakyaUni, sans-serif',
                    textAlign: 'center',
                    wordBreak: 'break-all',
                }}
            >
                {pathLabel}
            </Box>
        </Box>
    );
};

export default MobileDevPageInfoBar;
